<div fxLayout="column" fxFlex class="content-container" fxLayoutGap="5px">
  <app-grid-filter placeholder="Type '/' to bring up a list of available filters"
                   [showDateRange]="true" [defaultDateRange]="6"
                   [filterOptions]="filterOptions" (filterChangeEvent)="onFilterChanged($event)">
  </app-grid-filter>

  <div fxLayout.lt-md="column" fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="10px" class="total-rubic">
    <app-fax-summary-card fxFlex="auto" title="Incoming FAX" [value]="grandTotals.inboundFax"
                                secondIconClass="print"
                                [backgroundColor]="colors.primaryGreen"
                                (click)="showLogs($event, 'incoming')"></app-fax-summary-card>
    <app-fax-summary-card fxFlex="auto" title="Outgoing FAX" [value]="grandTotals.outboundFax"
                                secondIconClass="print"
                                [backgroundColor]="colors.primaryBlue"
                                (click)="showLogs($event, 'outgoing')"></app-fax-summary-card>
    <app-fax-summary-card fxFlex="auto" title="Failed FAX" [value]="grandTotals.failedFax"
                                secondIconClass="print_disabled"
                                [backgroundColor]="colors.primaryRed"
                                (click)="showLogs($event, 'failed')"></app-fax-summary-card>
    <app-fax-summary-card fxFlex="auto" title="Total FAX" [value]="grandTotals.totalFax" secondIconClass="print"
                                [backgroundColor]="colors.teal"
                                (click)="showLogs($event, 'all')"></app-fax-summary-card>
  </div>
  <div fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="5px">
    <div class="card" fxFlex>
      <div class="card-body" id="chartContainer1">
        <div style="height: 400px">
          <app-fax-chart-by-time [data]="timeSeriesTotals" [chartType]="timeSeriesType" [showExpand]="true"
                                 [startDate]="additionalFilter.startDate" [endDate]="additionalFilter.endDate"></app-fax-chart-by-time>
        </div>
      </div>
    </div>
  </div>
  <div fxLayout.lt-md="column" fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="10px">
    <div class="card" fxFlex>
      <div class="card-body">
        <h3 class="card-title">
          Top Phone Numbers
        </h3>
        <div class="items-container list-group">
          <ng-template ngFor let-item [ngForOf]="topNumbersByAll" let-i="index">
            <div class="top-item--title list-group-item">
              <span style="width: 40px; display: inline-block">{{i + 1}}</span>
              <span *ngIf="item.phoneNumber">{{item.phoneNumber | phoneNumber}} {{item.phoneNumberAlias}}</span>
            </div>
            <div class="top-item list-group-item">
              <div class="progress progress-info top-progress">
                <div class="progress-bar progress-bar-success"
                     [style.width]="(item.totalFax * 100 / (grandTotals.totalFax || 1)).toFixed(2) + '%'">
                </div>
              </div>
              <span
                class="top-item--text">{{item.totalFax}} {{item.direction == 'incoming' ? 'Incoming' : 'Outgoing' }}</span>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="card" fxFlex>
      <div class="card-body">
        <h3 class="card-title">
          Top Outgoing Phone Numbers
        </h3>
        <div class="items-container list-group">
          <ng-template ngFor let-item [ngForOf]="topOutgoingNumbersByAll" let-i="index">
            <div class="top-item--title list-group-item">
              <span style="width: 40px; display: inline-block">{{i + 1}}</span>
              <span *ngIf="item.phoneNumber">{{item.phoneNumber | phoneNumber}} {{item.phoneNumberAlias}}</span>
            </div>
            <div class="top-item list-group-item">
              <div class="progress progress-info top-progress">
                <div class="progress-bar progress-bar-success"
                     [style.width]="(item.totalFax * 100 / (grandTotals.outboundFax || 1)).toFixed(2) + '%'">
                </div>
              </div>
              <span
                class="top-item--text">{{item.totalFax}} {{item.direction == 'incoming' ? 'Incoming' : 'Outgoing' }}</span>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="card" fxFlex>
      <div class="card-body">
        <h3 class="card-title">
          Top Incoming Phone Numbers
        </h3>
        <div class="items-container list-group">
          <ng-template ngFor let-item [ngForOf]="topIncomingNumbersByAll" let-i="index">
            <div class="top-item--title list-group-item">
              <span style="width: 40px; display: inline-block">{{i + 1}}</span>
              <span *ngIf="item.phoneNumber">{{item.phoneNumber | phoneNumber}} {{item.phoneNumberAlias}}</span>
            </div>
            <div class="top-item list-group-item">
              <div class="progress progress-info top-progress">
                <div class="progress-bar progress-bar-success"
                     [style.width]="(item.totalFax * 100 / (grandTotals.inboundFax || 1)).toFixed(2) + '%'">
                </div>
              </div>
              <span
                class="top-item--text">{{item.totalFax}} {{item.direction == 'incoming' ? 'Incoming' : 'Outgoing' }}</span>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
